import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBagIcon } from 'lucide-react';
export function SocialProofPopup() {
  const names = ['Gabriela M.', 'Romina T.', 'Claudia P.', 'Natalia G.', 'Verónica S.', 'María L.', 'Carolina D.', 'Luciana F.', 'Andrea B.', 'Soledad R.'];
  const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'Santa Fe', 'Mar del Plata', 'Salta', 'La Plata', 'Neuquén'];
  const [isVisible, setIsVisible] = useState(false);
  const [currentName, setCurrentName] = useState(names[0]);
  const [currentCity, setCurrentCity] = useState(cities[0]);
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setCurrentName(randomName);
      setCurrentCity(randomCity);
      setIsVisible(true);
      setTimeout(() => setIsVisible(false), 4000);
    };
    const initialTimeout = setTimeout(showPopup, 15000);
    const interval = setInterval(showPopup, 30000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-209">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 md:bottom-8 left-4 md:left-8 z-50 bg-white rounded-xl shadow-2xl p-4 border border-gray-100 flex items-center gap-4 max-w-[300px] md:max-w-sm" data-id="element-210">
          <div className="bg-[#C4A7E7]/10 p-3 rounded-full flex-shrink-0" data-id="element-211">
            <ShoppingBagIcon className="w-6 h-6 text-[#C4A7E7]" data-id="element-212" />
          </div>
          <div data-id="element-213">
            <p className="text-sm text-gray-800 font-medium" data-id="element-214">
              <strong className="text-[#C4A7E7]" data-id="element-215">{currentName}</strong> de{' '}
              {currentCity}
            </p>
            <p className="text-xs text-gray-500 mt-0.5" data-id="element-216">
              acaba de comprar el MEGA KIT
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}